/**
 * AiPrice (AliPrice) Sourcing Tool — product sourcing / price-comparison helper
 *
 * Declares one web-accessible-resource entry, the glob assets/* , matched to http(s)
 * origins with no dynamic URL — so everything under assets/ is fetchable from any page at
 * a fixed URL. The bundled images are build-hashed (they rotate each release), so we probe
 * the stable, vendor-named script and stylesheet paths instead.
 *
 * Manifest verified against version 4.0.5.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'lenipkahddombkldhfmcnnjakmcepdlk';

export const alipriceSourcingTool: ExtensionDefinition = {
  id: ID,
  name: 'AiPrice(AliPrice) Sourcing Tool',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'assets/* exposed to http(s) origins with no dynamic URL. Bundled images are ' +
    'build-hashed, so detection uses the stable assets/js and assets/css paths.',
  signals: [
    {
      id: 'war-inject-script-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/js/inject-script.js — a stable, vendor-named script under the ' +
        'assets/ glob exposed to every http(s) origin.',
      weight: 1,
      run: () => probeFetch(ID, 'assets/js/inject-script.js'),
    },
    {
      id: 'war-content-script-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/js/content-script.js — the content-script bundle, a second stable ' +
        'path corroborating the identification.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/js/content-script.js'),
    },
    {
      id: 'war-content-script-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/css/content-script.css — the content-script stylesheet, a third ' +
        'independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/css/content-script.css'),
    },
  ],
};
